<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card :class="{'loading': loading}">
      <v-toolbar dark color="primary">
        <tk-btn icon dark @click="$emit('input', !value)">
          <v-icon>fas fa-times</v-icon>
        </tk-btn>
        <v-toolbar-title>{{ $t('ACCOUNT.RE_ARRANGE_ARTWORKS') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <tk-btn dark flat :loading="saving" @click="save">{{ $t('COMMON.SAVE') }}</tk-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-container fluid grid-list-xl pa-3 class="draggable-container">
        <draggable
          class="layout row wrap"
          v-model="artworks"
          v-bind="dragOptions"
          @start="drag=true"
          @end="drag=false"
        >
          <v-flex xs6 sm3 md2 lg1 xl1 v-for="artwork in artworks" :key="artwork.id">
            <base-card pa-2>
              <v-img
                aspect-ratio="1"
                class="grey lighten-2"
                sizes="80px"
                :src="artwork.media.url"
                :srcset="artwork.media.srcset"
                :style="{'background-color': artwork.media.color }"
              >
                <div v-if="!artwork.isForSale" class="sold-ribbon">
                  <span>{{ $t('COMMON.SOLD') }}</span>
                </div>
              </v-img>
            </base-card>
          </v-flex>
        </draggable>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import Grid from "vue-js-grid";
import { RepositoryFactory } from "@/services/RepositoryFactory";
import { ErrorHandler } from "@/utils/ErrorHandler";

const artworksRepo = RepositoryFactory.artworks();
const handler = new ErrorHandler();

export default {
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },

  components: {
    draggable: () => import("vuedraggable")
  },

  data() {
    return {
      loading: false,
      artworks: [],
      editable: true,
      saving: false
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost"
      };
    }
  },

  watch: {
    value: "fetchData"
  },

  methods: {
    async fetchData() {
      if (this.value === false) {
        this.artworks = [];
        return;
      }
      this.loading = true;
      await handler.handle(async () => {
        this.artworks = await artworksRepo.profileAllArtworks();
        console.log(this.artworks.map(artwork => artwork.id));
      });
      this.loading = false;
    },

    async save() {
      console.log("Save", this.artworks.map(artwork => artwork.id));
      this.saving = true;
      await handler.handle(async () => {
        await artworksRepo.sortArtworks(
          this.artworks.map(artwork => artwork.id)
        );
        this.$emit("sorted");
      });
      this.saving = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.draggable-container {
  max-width: 100% !important;
  .v-card {
    cursor: move;
    &:hover {
      opacity: 0.9;
    }
  }
  .ghost {
    .v-card {
      opacity: 0.5;
      border: 2px dashed #4a4a4a;
    }
  }

  .flip-list-move {
    transition: transform 0.5s;
  }

  .sold-ribbon {
    font-size: 1.2rem;
    padding: 4px;
    width: 134px;
  }
}
</style>


